<template>
   <div class="form-item">
      <label :for="id" v-if="labelText">{{ labelText }}</label>
      <textarea name="gts-textarea" :id="id" :placeholder="placeHolder" @input="$emit('input', $event.target.value)" :maxlength="maxlength" :cols="cols" :rows="rows"></textarea>
   </div>
</template>

<script>
export default {
   name: "UITextarea",
   props: {
      placeHolder: { String },
      id: { String },
      labelText: { String },
      maxlength: { String },
      cols: {
         type: String,
         default: "20",
      },
      rows: {
         type: String,
         default: "5",
      },
   },
};
</script>

<style lang="scss" scoped>
.form-item {
   width: max-content;
   height: max-content;

   & > label {
      margin-bottom: 8px;
   }

   & > textarea {
      width: 100%;
      padding: 8px 16px;
      border: 2px solid var(--gts-input-border);
      border-radius: 16px;
      font-size: 14px;
      color: var(--gray-700);
      outline: none;
      transition: 0.15s ease-in-out;

      &::placeholder {
         color: var(--gray-500);
      }

      &:focus,
      &:active {
         border-color: var(--accent-primary);
         /* box-shadow: 0 3px 5px 0 var(--accent-primary-alpha-50); */
         box-shadow: var(--gts-box-shadow);
      }
   }
}
</style>
